import {Box} from '@mantine/core';
import Head from 'next/head';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {GSSKT_HOST} from '../../../config/constants/hosts';
import {SectionTitle} from '../../../shared/components/SectionTitle';
import {TermsContainer} from './TermsContainer';

export const TermsPage: FC = () => {
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.pathname)}`;

  return (
    <>
      <Head>
        <title key="title">利用規約</title>
        <meta key="og:title" property="og:title" content="利用規約" />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <link rel="canonical" href={currentUrl} key="canonical" />
      </Head>
      <Box className="w-full max-w-[664px]">
        <SectionTitle order={1} title="利用規約" />
        <TermsContainer />
      </Box>
    </>
  );
};
